module.exports = __webpack_public_path__ + "img/walrus.13d88562.jpg";